import { useMemo } from "react";
import copito from "../../img/copito.png";

export default function FondoCopos(props) {
    const cantidad = props.copitos;
    const minDist = 40; // px de separación mínima

    const posiciones = useMemo(() => {
        const arr = [];

        function generaPos() {
            let intentos = 0;

            while (intentos < 50) {
                const top = Math.random() * 100;
                const left = Math.random() * 100;

                // Verificar distancia
                const ok = arr.every(p => {
                    const dx = (p.left - left) * window.innerWidth / 100;
                    const dy = (p.top - top) * window.innerHeight / 100;
                    return Math.sqrt(dx * dx + dy * dy) > minDist;
                });

                if (ok) return { top, left };
                intentos++;
            }

            return { top: Math.random() * 100, left: Math.random() * 100 };
        }

        for (let i = 0; i < cantidad; i++) arr.push(generaPos());
        return arr;
    }, []); // <- se genera una sola vez

    return (
        <div
            className="copito"
        >
            {posiciones.map((p, i) => (
                <img
                    key={i}
                    src={copito}
                    alt=""
                    style={{
                        position: "absolute",
                        width: "90px",
                        top: `${p.top}%`,
                        left: `${p.left}%`
                    }}
                />
            ))}
        </div>
    );
}
